module.exports = __webpack_public_path__ + "static/media/lanzhou.cbd9a612.png";